import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-555e9e95"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "form__button-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AHeading = _resolveComponent("AHeading")!
  const _component_ALabel = _resolveComponent("ALabel")!
  const _component_AInput = _resolveComponent("AInput")!
  const _component_AButton = _resolveComponent("AButton")!
  const _component_ALink = _resolveComponent("ALink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AHeading, { level: 1 }, {
      default: _withCtx(() => [
        _createTextVNode("パスワード再設定")
      ], undefined, true),
      _: 1
    }),
    _createElementVNode("form", {
      class: "form__container",
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.passwordNew()), ["prevent"]))
    }, [
      _createVNode(_component_ALabel, { for: "email" }, {
        default: _withCtx(() => [
          _createTextVNode("メールアドレス")
        ], undefined, true),
        _: 1
      }),
      _createVNode(_component_AInput, {
        class: "form__input",
        type: "text",
        name: "email",
        value: _ctx.email,
        placeholder: "onecareer@onecareer.jp",
        "validate-rule": _ctx.emailValidateRule,
        "validate-mode": "blur",
        onInput: _ctx.handleInput,
        onValidateBlur: _ctx.handleValidateBlur
      }, null, 8, ["value", "validate-rule", "onInput", "onValidateBlur"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_AButton, {
          round: "",
          fill: "",
          bold: "",
          size: "medium",
          disabled: _ctx.buttonDisabled,
          processing: _ctx.processing,
          class: "form__button"
        }, {
          default: _withCtx(() => [
            _createTextVNode("パスワード再設定メール送信")
          ], undefined, true),
          _: 1
        }, 8, ["disabled", "processing"])
      ])
    ], 32),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "form__link"
      }, [
        _createVNode(_component_ALink, {
          to: link.to
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(link.text), 1)
          ], undefined, true),
          _: 2
        }, 1032, ["to"])
      ]))
    }), 128))
  ]))
}